<ng-select [clearable]="true"
  [searchable]="true"
  [closeOnSelect]="true"
  [clearSearchOnAdd]="true"
  [searchFn]="customSearchFn"
  [placeholder]="placeholder"
  [(ngModel)]="selectedOption"
  [formControl]="searchControl"
  [ngClass]="{ 'is-invalid': searchControl.touched && searchControl.errors }"
  (search)="onSearch($event)"
  (focusout)="onFocusOut()"
  (change)="onOptionSelected($event)">
  @for (item of options; track item) {
    <ng-option [value]="item">
      <span [innerText]="item.name | translate"></span>
    </ng-option>
  }
</ng-select>
